module.exports = __webpack_public_path__ + "static/img/yxlogo_zh.2c56bca4.png";